import $ from "jquery";

if (document.querySelector(".card-slider")) {
    
    const cardSliders = document.querySelectorAll(".card-slider__slider");

    cardSliders.forEach(cardSlider => {
        $(cardSlider).slick({
            dots: true,
            appendDots: $(cardSlider.closest(".card-slider").querySelector(".card-slider__dots")),
            prevArrow: "<button type='button' class='slick-prev d-none d-lg-block'><i class='fal fa-chevron-left'></i></button>",
            nextArrow: "<button type='button' class='slick-next ml-auto ml-lg-0 mr-0'><i class='fal fa-chevron-right'></i></button>",
            appendArrows: $(cardSlider.closest(".card-slider").querySelector(".card-slider__arrows"))
        });
    });
}